import { useState } from "react";
import { useTranslation } from "react-i18next";

import { PortalTopBanners } from "@/components/Interface/Alert/PortalTopBanners";
import { DefaultPageLayout } from "@/components/Layout/BaseLayouts/DefaultPageLayout";
import { FocusRing } from "@/components/Layout/BaseLayouts/Footer/FocusRing";
import { FCC } from "@/types";
import { KEYBOARD_TAB_INDEX } from "@/utils/keyboardTabIndex";

import { LogInForm } from "./LogInForm";
import { RegisterForm } from "./RegisterForm";

const formSwitchClassName =
  "group relative inline-block w-fit cursor-pointer border-b border-solid border-foreground-primary pb-px text-body-xs !font-semibold text-foreground-primary outline-none hover:border-b-2 hover:pb-0 focus-visible:border-b-2 focus-visible:pb-0";

export const WelcomeScreen: FCC = () => {
  const { t } = useTranslation();
  const [switchForm, setSwitchForm] = useState(true);

  return (
    <DefaultPageLayout>
      <PortalTopBanners className="z-40 col-span-full" placement="welcome" />
      <div
        data-testid="welcome-content"
        className="col-span-full flex flex-col items-center"
      >
        {switchForm ? (
          <LogInForm enableMagicLinkLogin>
            <p className="text-body-xs leading-md text-foreground-primary">
              <span className="mr-1">
                {t("newWelcome.logInForm.noAccount")}
              </span>
              <button
                className={formSwitchClassName}
                type="button"
                tabIndex={KEYBOARD_TAB_INDEX}
                onClick={() => setSwitchForm(!switchForm)}
              >
                <FocusRing />
                {t("newWelcome.logInForm.registerNow")}
              </button>
            </p>
          </LogInForm>
        ) : (
          <RegisterForm
            handleVerifyEmailModalClose={() => setSwitchForm(!switchForm)}
          >
            <p className="text-body-xs leading-md text-foreground-primary">
              <span className="mr-1">
                {t("newWelcome.registerForm.accountExists")}
              </span>
              <button
                className={formSwitchClassName}
                type="button"
                tabIndex={KEYBOARD_TAB_INDEX}
                onClick={() => setSwitchForm(!switchForm)}
              >
                <FocusRing />
                {t("newWelcome.registerForm.logInNow")}
              </button>
            </p>
          </RegisterForm>
        )}
      </div>
    </DefaultPageLayout>
  );
};
